export default function Input({
    label,
    error,
    helperText,
    className = '',
    ...props
}) {
    return (
        <div className={`w-full ${className}`}>
            {label && (
                <label className="block text-sm font-medium mb-1.5">
                    {label}
                    {props.required && <span className="text-red ml-1">*</span>}
                </label>
            )}
            <input
                className={`input ${error ? 'border-red focus:ring-red' : ''}`}
                {...props}
            />
            {error && (
                <p className="mt-1 text-sm text-red">{error}</p>
            )}
            {helperText && !error && (
                <p className="mt-1 text-sm text-muted-light dark:text-muted-dark">
                    {helperText}
                </p>
            )}
        </div>
    );
}

